import { sortBy } from "lodash";
import {
  MeetingViewMeetingNodeNewPageFragmentFragment,
  TopicNodeNewPageFragmentFragment,
} from "types/graphql-schema";

import { currentUserVar } from "@cache/cache";
import { ignoredParticipantEmails } from "@helpers/constants";
import { classNames } from "@helpers/css";
import {
  assertEdgesNonNull,
  assertEdgesNonNullWithStringId,
} from "@helpers/helpers";

import IndividualNotes from "./individual-notes";

const IndividualNotesContainer = ({
  topic,
  meeting,
  className = "",
}: {
  topic: TopicNodeNewPageFragmentFragment;
  meeting: MeetingViewMeetingNodeNewPageFragmentFragment;
  className?: string;
}) => {
  const currentUser = currentUserVar();

  const individualNotes = assertEdgesNonNull(topic.individualNotes);
  const enabledNotes = individualNotes.filter(
    (individualNote) => individualNote.enabled,
  );
  const participantIdsWithNotes = enabledNotes.map(
    (individualNote) => individualNote.creator.id,
  );

  const meetingGroup = meeting.meetingGroup;
  if (!meetingGroup) return null;

  const participants = assertEdgesNonNullWithStringId(meeting.participants);
  return (
    <div
      className={classNames("flex flex-col gap-2 mt-2 empty:hidden", className)}
    >
      {sortBy(
        participants,
        (participant) => participant.user?.id !== currentUser.id, // put current user first.
      )
        .filter(
          (participant) =>
            // only show notes for participants with a user
            !!participant.user?.id &&
            // show notes for participants with notes, or all participants in 1:1s
            (participantIdsWithNotes.includes(participant.user?.id) ||
              (meetingGroup.isFormalOneonone &&
                topic.includesIndividualNotes)) &&
            // show notes for participants with an email that is not ignored
            participant.participantEmail &&
            !ignoredParticipantEmails.includes(participant.participantEmail),
        )
        .map((participant) =>
          !participant.user ? null : (
            <IndividualNotes
              key={participant.id}
              participant={participant}
              topic={topic}
              meeting={meeting}
            />
          ),
        )}
    </div>
  );
};

export default IndividualNotesContainer;
